export default __webpack_public_path__ + "static/media/store_sign_street_reduced.cc95a380.jpg";